export function scrollToPdpTabs() {
  window.setTimeout(() => document.getElementById("tabs")?.scrollIntoView(), 16);
}
